import { Box, SxProps, useTheme } from '@mui/material'
import React from 'react'
import { G1Nowifi } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  offlineIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: theme.zIndex.appBar - 1,
    color: theme.palette.error.main,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(4),
      right: theme.spacing(1),
    },
  },
}))

interface Props {
  isOffline?: boolean
  sxOverlay?: SxProps
  children?: React.ReactNode
  offlineIconStyle?: string
}

/**
 * Overlays a component with a grey drop and a no-wifi icon in case the system is offline.
 */
const OfflineOverlay: React.FC<Props> = ({ sxOverlay, offlineIconStyle, children, isOffline = false }) => {
  const { classes, cx } = useStyles()
  const theme = useTheme()

  const Overlay = (
    <>
      <G1Nowifi className={cx(classes.offlineIcon, offlineIconStyle)} />
      <Box
        sx={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          borderRadius: 1,
          backgroundColor: 'rgba(175, 175, 175, 0.5)',
          zIndex: theme.zIndex.appBar - 2,
          top: 0,
          ...sxOverlay,
        }}
      />
    </>
  )

  return (
    <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
      {isOffline && Overlay}
      {children}
    </Box>
  )
}

export default OfflineOverlay
